import { useMutation, useQuery, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { updatedExpenses } from "~/store/actions/actions.expenses";
import { updatedTimeRecords } from "~/store/actions/actions.timeRecords";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useProjectProgress = (projectId, config = {}) =>
  useQuery({
    ...config,
    queryKey: ["project-progress", projectId],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/progress`,
        signal,
      }),
  });

export const useMarkAsPaid = (id) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: () => {
      return fetch({
        url: `${Angie.api_url}/projects/${id}/mark-paid-time-project`,
        method: "POST",
      });
    },
    onSuccess: (r) => {
      queryClient.invalidateQueries(["project-progress", id]);
      queryClient.invalidateQueries(["uninvoiced-report"]);

      if (r?.time_records?.length > 0) {
        dispatch(updatedTimeRecords(r.time_records));
      }

      if (r?.expenses?.length > 0) {
        dispatch(updatedExpenses(r.expenses));
      }
    },
  });
};
